import './App.css';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import FileUploader from "./FileUploader";

function App() {
  return (
    <div className="App">
      <FileUploader />
    </div>
  );
}

export default App;
